<template>
  <v-row class="eventform match-height">
    <v-col cols="12">
      <v-card>
        <v-card-title>{{ $t("Tapahtumat") }}</v-card-title>
        <v-card-text>
          <v-form v-on:submit.prevent="submit" ref="form">
            <div class="mb-4">
              <v-radio-group :rules="inputRules.group" v-model="eventModel.group" :label="$t('Julkaise ryhmään')"
                hide-details="auto">
                <!-- <v-radio v-for="n in 3" :key="n" :label="`Radio ${n}`" :value="n"></v-radio> -->
                <v-radio v-for="group in user.admin_groups" :key="group.id" required :value="group.id"
                  :label="group.name" />
              </v-radio-group>
            </div>

            <v-datetime-picker dateFormat="dd.MM.yyyy" :label="$t('Tapahtuman alkuaika')" v-model="eventModel.time"
              :date-picker-props="{
                firstDayOfWeek: 1
              }" :time-picker-props="{
                format: '24hr',
              }" :textFieldProps="{
                outlined: 'outlined',
                'hide-details': '',
              }">
              <template slot="dateIcon">
                <v-icon>
                  {{ icons.mdiCalendar }}
                </v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>
                  {{ icons.mdiClockOutline }}
                </v-icon>
              </template>
            </v-datetime-picker>
            <v-input type="hidden" :rules="inputRules.startTime" v-model="eventModel.time" hide-details="auto"
              class="mb-2"></v-input>

            <v-datetime-picker dateFormat="dd.MM.yyyy" :label="$t('Tapahtuman päättymisaika')"
              v-model="eventModel.end_time" :date-picker-props="{
                firstDayOfWeek: 1
              }" :time-picker-props="{
                format: '24hr',
              }" :textFieldProps="{
                outlined: 'outlined',
                'hide-details': '',
              }">
              <template slot="dateIcon">
                <v-icon>
                  {{ icons.mdiCalendar }}
                </v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>
                  {{ icons.mdiClockOutline }}
                </v-icon>
              </template>
            </v-datetime-picker>
            <v-input type="hidden" :rules="inputRules.endTime" v-model="eventModel.end_time" hide-details="auto"
              class="mb-2"></v-input>

            <v-switch inset v-model="eventModel.enrollment" :label="$t('Ilmoittautuminen')" hide-details
              class="mb-4"></v-switch>

            <template v-if="eventModel.enrollment">
              <v-switch inset hide-details class="mb-4" v-model="eventModel.enrollment_comment"
                :label="$t('Kommentti ilmoittautumisen yhteydessä')"></v-switch>

              <v-datetime-picker dateFormat="dd.MM.yyyy" :label="$t('Ilmoittautuminen päättyy')"
                v-model="eventModel.enrollment_ends" :date-picker-props="{
                  firstDayOfWeek: 1
                }" :time-picker-props="{
                  format: '24hr',
                }" :textFieldProps="{
                  outlined: 'outlined',
                  class: 'mb-4',
                  'hide-details': 'auto',
                }">
                <template slot="dateIcon">
                  <v-icon>
                    {{ icons.mdiCalendar }}
                  </v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>
                    {{ icons.mdiClockOutline }}
                  </v-icon>
                </template>
              </v-datetime-picker>
              <v-input type="hidden" hide-details="auto" class="mb-2" :rules="inputRules.enrollmentEndTime"
                v-model="eventModel.enrollment_ends"></v-input>
              <br />

              <v-select v-model="eventModel.enrollment_visibility" :items="enrollmentVisibilityOptions"
                :label="$t('Ilmoittautumisten näkyvyys')" item-text="text" item-value="value" outlined
                hide-details="auto" class="mb-4"></v-select>

            </template>

            <v-card :key="forceUpdateTranslationsKey">
              <v-tabs v-model="tab" backgroundColor="#eee" grow>
                <v-tab v-for="lang in tenant.languages" :key="'langtab-' + lang.code">
                  <img :src="lang.icon" style="max-height: 20px" />
                  &nbsp;&nbsp;{{ lang.name }}
                  &nbsp;
                  <v-icon v-if="langOk(eventModel.translations, lang.code, [
                    'title',
                    'description',
                  ])
                  " color="success">
                    {{ icons.mdiCheck }}
                  </v-icon>
                  <v-icon v-else color="error">
                    {{ icons.mdiBlockHelper }}
                  </v-icon>
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item v-for="lang in tenant.languages" :key="'langtabitem-' + lang.code">
                  <div style="padding: 20px">
                    <img :src="lang.icon" style="max-height: 14px" />
                    <br />
                    <br />
                    <v-text-field outlined :id="'event-title-' + lang.code"
                      v-model="eventModel.translations[lang.code].title" :label="$t('Otsikko')" hide-details
                      class="mb-4" />
                    <div>
                      <quill-editor height="400" ref="myQuillEditor"
                        v-model="eventModel.translations[lang.code].description" :options="editorOption" />
                    </div>
                  </div>

                  <div class="mx-5" v-if="tenant.settings.auto_translations_enabled">
                    <AutoTranslateButton :current="lang" :languages="tenant.languages" :is-translating="isTranslating"
                      @click="translate" translation-errors="translationErrors" :errors="translationErrors">
                    </AutoTranslateButton>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
            <v-input type="hidden" :rules="inputRules.translations" v-model="eventModel.translations"></v-input>
            <v-card outlined class="mt-3">
              <v-card-title>{{ $t("Liitteet") }}</v-card-title>
              <v-card-text>

                <v-list>
                  <v-list-item v-for="attachment in eventModel.attachments" :key="attachment.id">
                    <v-list-item-icon>
                      <v-icon color="primary">
                        {{ icons.mdiAttachment }}
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      {{ attachment.name }}
                    </v-list-item-content>
                    <v-list-item-icon @click="removeAttachment(attachment)" style="cursor: pointer">
                      <v-icon color="secondary">
                        {{ icons.mdiDeleteOutline }}
                      </v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list>
                <v-file-input outlined ref="attachmentInput" :label="$t('Lisää uusi liitetiedosto')"
                  @change="saveAttachment" accept=".jpeg,.jpg,.png, .pdf, .doc, .docx, .ppt, .pptx, .xlsx, .xls">
                </v-file-input>
              </v-card-text>
            </v-card>

            <div class="mt-7 mb-4">
              <v-datetime-picker dateFormat="dd.MM.yyyy" :label="$t('Julkaisuaika')" v-model="eventModel.release_date"
                :date-picker-props="{
                  firstDayOfWeek: 1
                }" :time-picker-props="{
                  format: '24hr',
                }" :textFieldProps="{
                  outlined: 'outlined',
                  'hide-details': '',
                }">
                <template slot="dateIcon">
                  <v-icon>
                    {{ icons.mdiCalendar }}
                  </v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>
                    {{ icons.mdiClockOutline }}
                  </v-icon>
                </template>
              </v-datetime-picker>
            </div>

            <v-switch v-model="eventModel.published" inset persistent-hint :hint="eventModel.published
              ? (eventModel.release_date ? $t('Tapahtuma julkaistaan julkaisuaikana') : $t('Tapahtuma julkaistaan heti'))
              : $t('Tapahtuma tallennetaan luonnoksena')
              " :label="$t('Julkaise')"></v-switch>
            <br />

            <v-btn color="error" v-if="eventModel.id" @click="removeEvent" class="mr-3">{{ $t("Poista") }}</v-btn>
            <v-btn color="primary" @click="submit">{{ $t("Tallenna") }}</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
      <v-snackbar v-model="translationCompleted" color="success">
        <template #default>
          <v-icon>{{ icons.mdiCheck }}</v-icon>
          {{ $t('Käännös suoritettu. Varmista käännöksen oikeellisuus ennen tallentamista.') }}
        </template>
      </v-snackbar>
    </v-col>
  </v-row>
</template>

<script>
import { onMounted, reactive, ref } from "@vue/composition-api";
import adminApi from "@/api/admin";
import { useRouter } from "@/@core/utils";
import useAuth from "@/useAuth";
import { useTranslations } from "@/@core/libs/i18n";
import {
  convertTranslationMarkdownToHtml,
  convertTranslationsHtmlToMarkdown,
  getValidTranslations,
  translateObjectTranslations,
  langOk,
} from "@/@core/utils/translation_helpers";
import {
  mdiCheck,
  mdiBlockHelper,
  mdiClockOutline,
  mdiCalendar,
  mdiAttachment,
  mdiDeleteOutline,
  mdiPlus,
  mdiHandPointingUp,
  mdiMap,
  mdiChatOutline,
  mdiArrowRight
} from "@mdi/js";
import moment from "moment";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { i18n } from "@/plugins/i18n";
import ImageUploader from 'quill-image-uploader';
import Quill from 'quill';
import 'quill-paste-smart';
import AutoTranslateButton from "@/components/AutoTranslateButton.vue";
import { MAX_FILE_SIZE } from "@core/utils/constants";

Quill.register("modules/imageUploader", ImageUploader);

export default {
  components: {
    quillEditor,
    AutoTranslateButton
  },
  props: ["id"],
  setup(props) {
    const { router } = useRouter();
    const { tenant, user } = useAuth();
    const formIsValid = ref(true);
    const tab = ref(null);
    const form = ref(null);
    const forceUpdateTranslationsKey = ref(new Date().toString());
    const attachmentInput = ref(null);
    const isTranslating = ref(false);
    const translationErrors = ref([]);
    const translationCompleted = ref(false);
    const eventModel = reactive({
      id: null,
      group: null,
      time: "",
      end_time: null,
      release_date: null,
      published: false,
      enrollment: false,
      enrollment_visibility: 0,
      enrollment_ends: null,
      enrollment_comment: false,
      translations: {},
      attachments: []
    });

    tenant.value.languages.forEach((lang) => {
      eventModel.translations[lang.code] = {
        title: "",
        description: "",
      };
    });


    const forceUpdateTranslations = () => {
      forceUpdateTranslationsKey.value = new Date().toString();
    }

    const editorOption = {
      modules: {
        clipboard: {
          keepSelection: true,
          substituteBlockElements: false,
          magicPasteLinks: true,
        },
        toolbar: [
          ["bold", "italic"],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          ["link", "image"],
        ],
        imageUploader: {
          upload: (file) => {
            return new Promise(async (resolve, reject) => {

              const res = await adminApi.uploadImage(file);

              if (res.ok) {
                resolve(res.data);
              }
              else {
                reject("Image upload failed");
              }
            });
          },
        },
      },
    };
    const inputRules = {
      group: [(v) => !!v || i18n.t("Ryhmä on pakollinen")],
      translations: [
        (v) => validateLangs() || i18n.t("Otsikko ja teksti on pakollinen"),
      ],
      startTime: [(v) => !!v || i18n.t("Alkuaika on pakollinen")],
      endTime: [
        (v) => validateEventTime(v) || i18n.t("Tarkista päättymisaika"),
      ],
      enrollmentEndTime: [
        (v) =>
          validateEnrollmentEndTime(v) ||
          i18n.t("Tarkista ilmoittautumisen päättymisaika"),
      ],
    };

    const fetchEvent = async (id) => {
      const response = await adminApi.getEvent(id);
      if (response.ok) {
        eventModel.id = response.data.id;
        eventModel.group = response.data.group;
        eventModel.published = response.data.published;
        eventModel.enrollment = response.data.enrollment;
        eventModel.enrollment_comment = response.data.enrollment_comment;
        eventModel.enrollment_visibility = response.data.enrollment_visibility ?? 0;
        eventModel.attachments = response.data.attachments;

        ["time", "end_time", "enrollment_ends", "release_date"].forEach((dateProp) => {
          if (response.data[dateProp]) {
            const d = moment(response.data[dateProp]);
            eventModel[dateProp] = d.format("DD.MM.YYYY HH:mm");
          }
        });

        eventModel.translations = {};
        tenant.value.languages.forEach((lang) => {
          if (response.data.translations[lang.code]) {
            eventModel.translations[lang.code] =
              response.data.translations[lang.code];
          } else {
            eventModel.translations[lang.code] = {
              title: "",
              description: "",
            };
          }
        });
        convertTranslationMarkdownToHtml(eventModel.translations, [
          "description",
        ]);
      } else {
        alert(response.error);
      }
    };

    const submit = async () => {
      formIsValid.value = true;
      if (form.value.validate()) {
        const saveEvent = Object.assign({}, eventModel);

        saveEvent.translations = getValidTranslations(eventModel.translations, [
          "title",
          "description",
        ]);
        saveEvent.attachments = eventModel.attachments.map((a) => a.id);

        const response = await adminApi.saveEvent(saveEvent);

        if (response.ok) {
          router.push({ name: "admin-event-list" });
        } else {
          alert(response.error);
        }
      } else {
        formIsValid.value = false;
      }
    };

    const enrollmentVisibilityOptions = [
      { value: 0, text: i18n.t("Vain ylläpitäjät") },
      { value: 1, text: i18n.t("Näytä vain ilmoittautuneiden määrä") },
      { value: 2, text: i18n.t("Näytä ilmoittautuneiden lista") },
    ];

    const removeEvent = async () => {
      if (confirm(i18n.t("Haluatko varmasti poistaa tapahtuman?"))) {
        const response = await adminApi.deleteEvent(eventModel.id);
        if (response.ok) {
          router.replace({ name: "admin-event-list" });
        } else {
          alert(response.error);
        }
      }
    };

    const translate = async (fromLangCode, toLangs) => {

      translationErrors.value = [];

      if (langOk(eventModel.translations, fromLangCode, ["title", "description"])) {
        isTranslating.value = true;
        const errors = await translateObjectTranslations(eventModel.translations, fromLangCode, toLangs, ["title", "description"]);
        translationErrors.value = errors;
        forceUpdateTranslations();
        isTranslating.value = false;

        if (errors.length == 0) {
          translationCompleted.value = true;
        }

      }
      else {
        alert("Otsikko ja teksti on pakollinen ennen käännöstä");
      }
    }

    const validateLangs = () => {
      let valid = false;
      tenant.value.languages.forEach((lang) => {
        if (
          langOk(eventModel.translations, lang.code, ["title", "description"])
        )
          valid = true;
      });

      if (valid) {
        return true;
      } else {
        return i18n.t("Otsikko tai teksti puuttuu");
      }
    };

    const validateEventTime = (v) => {
      if (!v) return true;

      let start;
      if (typeof eventModel.time == "string")
        start = moment(eventModel.time, "DD.MM.YYYY HH:mm");
      else start = moment(eventModel.time);

      let end;
      if (typeof eventModel.end_time == "string")
        end = moment(eventModel.end_time, "DD.MM.YYYY HH:mm");
      else end = moment(eventModel.end_time);

      return end.isSameOrAfter(start);
    };

    const validateEnrollmentEndTime = (v) => {
      if (!v) return true;

      let start;
      if (typeof eventModel.time == "string")
        start = moment(eventModel.time, "DD.MM.YYYY HH:mm");
      else start = moment(eventModel.time);

      let enrollmentEnd;
      if (typeof eventModel.enrollment_ends == "string")
        enrollmentEnd = moment(eventModel.enrollment_ends, "DD.MM.YYYY HH:mm");
      else enrollmentEnd = moment(eventModel.enrollment_ends);

      return enrollmentEnd.isSameOrBefore(start);
    };


    const saveAttachment = async (file) => {
      if (file) {
        if (file.size > MAX_FILE_SIZE) {
          alert(i18n.t('Tiedoston maksimikoko on 10MB'));
          return;
        }

        const response = await adminApi.saveEventAttachment(file);

        if (response.status == 201) {
          eventModel.attachments.push(response.data);
        }
        else {
          alert(response.error);
        }
        attachmentInput.value = "";
      }
    };

    const downloadAttachment = async (attachment) => {
      // const response = await adminApi.downloadNewsAttachment(
      //   news.id,
      //   attachment.id
      // );

      // if (response.ok) {
      //   download(response.data, attachment.name);
      // } else {
      //   alert(response.error);
      // }
    };

    const removeAttachment = async (attachment) => {
      eventModel.attachments = eventModel.attachments.filter(
        (a) => a.id !== attachment.id
      );
    };

    onMounted(() => {
      if (props.id) {
        fetchEvent(props.id);
      }
    });

    return {
      eventModel,
      enrollmentVisibilityOptions,
      tenant,
      user,
      removeEvent,
      submit,
      inputRules,
      langOk,
      validateLangs,
      formIsValid,
      tab,
      form,
      editorOption,
      isTranslating,
      attachmentInput,
      translationErrors,
      forceUpdateTranslationsKey,
      translationCompleted,
      saveAttachment,
      downloadAttachment,
      removeAttachment,
      translate,
      icons: {
        mdiCheck,
        mdiBlockHelper,
        mdiClockOutline,
        mdiCalendar,
        mdiAttachment,
        mdiDeleteOutline,
        mdiPlus,
        mdiHandPointingUp,
        mdiMap,
        mdiChatOutline,
        mdiArrowRight
      },
    };
  },
};
</script>


<style>
.eventform .ql-editor p {
  font-size: 1.2em;
  line-height: 1.8em;
}

.eventform .ql-editor {
  min-height: 200px;
}
</style>
